import React, { useState, Fragment } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import { getAllVehiclesAsRack, shareLink, resetShareLink } from '../../features/assets/assetsSlice';

const ShareLinkModal = ({ shareLinkOpen, handleShareLinkClose, assetId }) => {
    const dispatch = useDispatch();


    const rack = useSelector(getAllVehiclesAsRack);
    const assetData = rack[`${assetId}`];
    const regn = assetData && assetData.vehicleDevice.regn;
    const link = assetData && assetData.shareLink;

    const [hours, setHours] = useState(0);
    const [days, setDays] = useState(1);

    const handleSubmit = () => {
        //console.log("sharelink", assetId, hours, days);
        dispatch(shareLink({
            assetId, duration: hours + 24 * days
        }));

    }

    const newLink = () => {
        dispatch(resetShareLink({
            assetId
        }));
    }

    return (
        <Dialog open={shareLinkOpen} onClose={handleShareLinkClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title"><b>Share Link: {regn}</b></DialogTitle>

            {
                link ?
                    <Fragment>
                        <DialogContent>
                            <DialogContentText>
                                Share this link with anyone you like.
                            </DialogContentText>
                            <br />
                            <Typography variant="body1">
                                {link}
                            </Typography>
                            <br />
                            <br />
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<FileCopyIcon />}
                                onClick={() => { navigator.clipboard.writeText(link) }}
                            >
                                Copy Link
                            </Button>

                        </DialogContent>
                    </Fragment>
                    :
                    <Fragment>
                        <DialogContent>
                            <DialogContentText>
                                Enter the period for which you would like the link to remain active.
                            </DialogContentText>
                            <form>
                                <TextField
                                    variant="standard"
                                    autoFocus
                                    id="days"
                                    label="Days"
                                    type="number"
                                    value={days}
                                    onChange={(e) => setDays(e.target.value)}
                                />
                                <br />
                                <br />
                                <TextField
                                    variant="standard"
                                    autoFocus
                                    id="hours"
                                    label="Hours"
                                    type="number"
                                    value={hours}
                                    onChange={(e) => setHours(e.target.value)}
                                />
                                <br />
                                <br />
                                <Button onClick={handleSubmit} color="primary">
                                    Generate Link
                                </Button>
                            </form>

                        </DialogContent>
                    </Fragment>
            }

            <DialogActions>
                {
                    link && <Button onClick={newLink} color="primary">
                        Get New Link
                    </Button>
                }

                <Button onClick={handleShareLinkClose} color="primary">
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ShareLinkModal;